import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { CartService } from '../../../../services/cart.service'

@Component({
  selector: 'bmcore-cart-counter-icon',
  templateUrl: './bmcore-cart-counter-icon.component.html',
  styleUrls: ['./bmcore-cart-counter-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreCartCounterIconComponent implements OnInit {
  trackCount: number

  isAnimating = false

  animationTimer: number

  animationTimeout = 400

  constructor(private cartService: CartService) {}

  ngOnInit(): void {
    this.cartService.addSubscriber('group-updated', this.getTracksCount.bind(this))
    this.getTracksCount({ onInit: true })
  }

  getTracksCount({ onInit } = { onInit: false }) {
    const newTrackCount = this.cartService.getBeats().length
    const trackCountChanged = this.trackCount !== newTrackCount

    if (trackCountChanged) {
      this.trackCount = newTrackCount

      if (!onInit) {
        this.startAnimation()
      }
    }
  }

  startAnimation() {
    if (!this.animationTimer) {
      this.isAnimating = true

      this.animationTimer = setTimeout(() => {
        this.isAnimating = false
        clearTimeout(this.animationTimer)
        this.animationTimer = undefined
      }, this.animationTimeout)
    }
  }
}
